var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasData)?_c('div',{staticClass:"kpi-history-chart mt-6"},[_c('h3',{staticClass:"kpi-history-chart-title mb-4"},[_vm._v("Your KPI score over evaluations")]),_c('div',{staticClass:"kpi-history-chart-container"},[_c('canvas',{ref:"chartCanvas"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }